import { User } from './types/user';
import { Workpaper, WorkpaperRoleEnum } from './types/workpaper';

export const intercomEvents = {
    user: {
        adminResetMFA: {
            event: 'user-mfa-reset-by-admin',
            metaData: (user: User) => {
                return {
                    description: 'Admin has reset a user`s MFA',
                    resetUserId: user.id,
                    resetUser: `${user.firstName} ${user.lastName}`,
                };
            },
        },
        userResetMFA: {
            event: 'user-mfa-reset',
            metaData: () => {
                return {
                    description: 'User has reset their account`s MFA',
                };
            },
        },
    },
    carryForward: {
        linkPriorWorkpaper: {
            event: 'link-prior-workpaper',
            metaData: (workpaperId: string, priorWorkpaperId: string) => {
                return {
                    description: 'Linked workpaper to a prior workpaper',
                    workpaperId,
                    priorWorkpaperId,
                };
            },
        },
        carryForwardWorksheetEntries: {
            event: 'carry-forward-worksheet-entry',
            metaData: (workpaperId: string, worksheetId: string, priorWorksheetId: string, entriesCarriedForwardCount: number) => {
                return {
                    description: 'User carried forward entries from inside a worksheet',
                    workpaperId,
                    worksheetId,
                    priorWorksheetId,
                    entriesCarriedForwardCount,
                };
            },
        },
        carryForwardCalculation: {
            event: 'carry-forward-calculation',
            metaData: (workpaperId: string, calculationId: string, priorCalculationId: string) => {
                return {
                    description: 'User carried forward a calculation',
                    workpaperId,
                    calculationId,
                    priorCalculationId,
                };
            },
        },
        bulkCarryForwardResources: {
            event: 'bulk-carry-forward-resources',
            // if adding ability to carry forward additional resources in bulk in future, add additional param below.
            metaData: (workpaperId: string, priorWorkpaperId: string, entriesCarriedForwardCount: number) => {
                return {
                    description: 'Carried forward resources in bulk',
                    workpaperId,
                    priorWorkpaperId,
                    entriesCarriedForwardCount,
                };
            },
        },
    },

    trialBalance: {
        accountRefresh: {
            event: 'trial-balance-refresh-account',
            metaData: (workpaper: Workpaper) => {
                return {
                    description: 'Refreshed trial balance within an account',
                    workpaperId: workpaper.id,
                };
            },
        },
    },

    account: {
        mapWorkpaperAccounts: {
            event: 'map-workpaper-accounts',
            metaData: (workpaperId: string, accountsConfirmed: number, source: string) => {
                return {
                    workpaperId,
                    accountsConfirmed: accountsConfirmed,
                    source,
                    description: `${accountsConfirmed} workpaper accounts mapped from the ${source} page`,
                };
            },
        },
    },
    entities: {
        exportDataToCsv: {
            event: 'export-entities',
        },
    },
    workpaper: {
        exportDataToCsv: {
            event: 'workpaper-export-to-csv',
        },
        certified: {
            event: 'workpaper-certified',
            metaData: (role: WorkpaperRoleEnum) => {
                return {
                    role,
                };
            },
        },
        completed: {
            event: 'workpaper-completed',
        },
    },
    worksheet: {
        excluded: {
            event: 'worksheet-excluded',
            metaData: (count: number) => {
                return {
                    worksheetCount: count,
                };
            },
        },
        assigned: {
            event: 'worksheet-assigned',
            metaData: (count: number) => {
                return {
                    worksheetCount: count,
                };
            },
        },
        unassigned: {
            event: 'worksheet-unassigned',
            metaData: (count: number) => {
                return {
                    worksheetCount: count,
                };
            },
        },
        reviewed: {
            event: 'worksheet-reviewed',
            metaData: (count: number) => {
                return {
                    worksheetCount: count,
                };
            },
        },
    },
    groups: {
        exportDataToCsv: {
            event: 'export-groups',
        },
    },
    procedure: {
        checked: {
            event: 'procedure-checked',
        },
        notApplicable: {
            event: 'procedure-not-applicable',
        },
        addedNote: {
            event: 'procedure-note-created',
        },
    },
    checklist: {
        completed: {
            event: 'checklist-item-completed',
        },
        notApplicable: {
            event: 'checklist-item-not-applicable',
        },
    },
    journal: {
        created: {
            event: 'journal-created',
        },
    },
    calculation: {
        created: {
            event: 'calculation-created',
        },
    },
    internalComment: {
        created: {
            event: 'internal-comment-created',
        },
    },
    clientQuery: {
        created: {
            event: 'client-query-created',
        },
    },
    file: {
        document: {
            event: 'document-created',
        },
        link: {
            event: 'link-created',
        },
    },
};
